import { Company } from "../Authentication/Authentication.constants";
import * as yup from "yup";

export interface CompanyUpdateResponse {
  id: number;
  name: string;
  address: string;
  email: string;
  phone_number1: string;
  phone_number2?: string;
  phone_number3?: string;
  licence_type: string;
  status: number;
}

export interface CompanyUpdateRequest {
  companyId: any;
  name: string;
  address: string;
  email: string;
  phone_number1: string;
  phone_number2?: string | null;
  phone_number3?: string | null;
  licence_type?: string;
}

type Sms = {
  id: number;
  content: string;
  custom_title: string;
  content_type: string;
};

export interface SmsResponse extends Array<Sms> {}

export interface SmsCreateRequest {
  content: string;
  custom_title: string;
  content_type: string;
}

export interface SmsCreateResponse {
  id: number;
  content: string;
  custom_title: string;
  content_type: string;
}

export interface SmsUpdateRequest {
  smsId: number;
  content: string;
  custom_title: string;
  content_type: "maintenance" | "payment";
}

export interface SmsUpdateResponse {
  smsId: number;
  content: string;
  custom_title: string;
  content_type: "maintenance" | "payment";
}

export const companyUpdateSchema = yup.object().shape({
  name: yup.string().required("Müşteri adı boş bırakılamaz"),
  email: yup
    .string()
    .email("Geçerli bir email adresi giriniz")
    .required("Email boş bırakılamaz"),
  phone_number1: yup
    .string()
    .required("Telefon numarası boş bırakılamaz")
    .matches(/^0[0-9]{10}$/, "Geçerli bir telefon numarası girin"),
  phone_number2: yup
    .string()
    .transform((value) => (value === "" ? undefined : value))
    .nullable()
    .matches(/^0[0-9]{10}$/, "Geçerli bir telefon numarası girin"),
  phone_number3: yup
    .string()
    .transform((value) => (value === "" ? undefined : value))
    .nullable()
    .matches(/^0[0-9]{10}$/, "Geçerli bir telefon numarası girin"),
});

export interface CompanyModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalType?: string;
  userData?: Company;
}

export const ContentTypes = {
  maintenance: "maintenance",
  payment: "payment",
};
